import { SelectCampaignListPage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/marketing/$id/select-list'].update({
        staticData: { title: { page: 'Campaign.SelectList.Heading', forWebinar: true } },
        component: authGuard(SelectCampaignListPage, { isWhitelabel: true, canManageEmailLists: true, canBroadcast: true })
    });
};
